// src/components/pdf-reader/PageControls.jsx
import React from 'react';
import { Box, Button, Typography } from '@mui/material';

export default function PageControls({ currentPage, totalPages, onPrev, onNext }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        justifyContent: 'center',
        flexWrap: 'wrap'
      }}
    >
      <Button
        variant="outlined"
        onClick={onPrev}
        disabled={currentPage <= 1}
      >
        ◀ Prev
      </Button>

      <Typography variant="body1">
        Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
      </Typography>

      <Button
        variant="outlined"
        onClick={onNext}
        disabled={currentPage >= totalPages}
      >
        Next ▶
      </Button>
    </Box>
  );
}
